var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCategoria(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.381,
    height: 16.139,
    viewBox: "0 0 17.381 16.139",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-md-pricetags",
    "data-name": "Icon ionic-md-pricetags",
    transform: "translate(-2.249 -3.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2498",
    "data-name": "Caminho 2498",
    d: "M24.372,7.523v5.47l-8.256,7.9a1.768,1.768,0,0,0,1.117.477,1.933,1.933,0,0,0,1.218-.477l7.395-6.972V8.959Z",
    transform: "translate(-6.215 -1.859)",
    fill: "#64c2c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2499",
    "data-name": "Caminho 2499",
    d: "M15.906,3.375H9.7L2.727,10.653a1.588,1.588,0,0,0-.477,1.1,1.7,1.7,0,0,0,.477,1.238l4.8,4.8a1.781,1.781,0,0,0,1.117.485,1.936,1.936,0,0,0,1.214-.485l7.286-6.964V4.616ZM14.715,7.359a1.243,1.243,0,1,1,.83-.83A1.208,1.208,0,0,1,14.715,7.359Z",
    transform: "translate(0)",
    fill: "#64c2c8"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoria);
export default __webpack_public_path__ + "static/media/categoria.436895f1d204496983e7774fe19bf612.svg";
export { ForwardRef as ReactComponent };